const aboutDocApointData = [
  {
    id: 1,
    title: "Our Story",
    description:
      "Nirog Sathi was born out of a simple idea: to connect patients with the healthcare they need, quickly and efficiently. We understand the frustration of long wait times, confusing appointment processes, and the difficulty of finding the right specialist. That's why we set out to create a platform that puts patients and doctors in control, providing a seamless and secure way to access healthcare.",
  },
  {
    id: 2,
    title: "Our Commitment",
    description:
      "At Nirog Sathi, we are committed to offering you the best in healthcare services. Our platform is designed with your convenience and well-being in mind. We believe that every patient deserves prompt and easy access to medical expertise. Whether you're looking for a trusted family physician, a specialist in a particular field, or seeking the convenience of telemedicine, we're here to serve your healthcare needs.",
  },
  {
    id: 3,
    title: "Our Vision",
    description:
      "We envision a future where healthcare is accessible, efficient, and patient-centered. While we're just getting started, we're dedicated to continuously improving and expanding our services to meet your evolving needs.",
  },
];

const whyToChooseDocApoint = [
  {
    id: 1,
    title: "Simplicity",
    description:
      "Our platform offers a user-friendly experience, allowing you to find and book appointments with just a few clicks.",
  },
  {
    id: 2,
    title: "Quality",
    description:
      "We connect you with a diverse range of certified doctors and specialists, ensuring you receive top-notch medical care.",
  },
  {
    id: 3,
    title: "Security",
    description:
      "Your privacy and security are our top priorities. We employ industry-standard encryption and secure payment processing for your peace of mind.",
  },
];

export { aboutDocApointData, whyToChooseDocApoint };
